import { render } from "./popoverIcon.vue?vue&type=template&id=606a51ec&scoped=true&ts=true"
import script from "./popoverIcon.vue?vue&type=script&lang=ts"
export * from "./popoverIcon.vue?vue&type=script&lang=ts"

import "./popoverIcon.vue?vue&type=style&index=0&id=606a51ec&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-606a51ec"]])

export default __exports__